module.exports = __webpack_public_path__ + "img/5be6ce1.svg";